package br.com.vvrefeicoes.portal.core.ui.theme

import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.ReadOnlyComposable

object PortalTheme {
    val extraColors: AppExtraColors
        @Composable
        @ReadOnlyComposable
        get() = LocalAppExtraColors.current
}

@Composable
fun AppTheme(content: @Composable () -> Unit) {
    val typography = appTypography()
    CompositionLocalProvider(
        LocalAppExtraColors provides AppLightExtraColors,
    ) {
        MaterialTheme(
            colorScheme = AppLightColors,
            typography = typography,
            shapes = AppShapes,
            content = content,
        )
    }
}
